import { render, staticRenderFns } from "./logisticsCompanyEdit.vue?vue&type=template&id=27f9c7c0&scoped=true&"
import script from "./logisticsCompanyEdit.vue?vue&type=script&lang=js&"
export * from "./logisticsCompanyEdit.vue?vue&type=script&lang=js&"
import style0 from "./logisticsCompanyEdit.vue?vue&type=style&index=0&id=27f9c7c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f9c7c0",
  null
  
)

component.options.__file = "logisticsCompanyEdit.vue"
export default component.exports